import { createRouter, createWebHistory } from 'vue-router'
import {
  isPublicRoute,
  isAuthenticatedRoute,
  isAdminOnlyRoute,
  getRequiredModule,
  hasModuleRight,
  getFirstAuthorizedRoute
} from './routePermissions'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../vues/pages/loginPage.vue')
  },
  {
    path: '/lost-password',
    name: 'lost-password',
    component: () => import('../vues/pages/lostPasswordPage.vue')
  },
  {
    path: '/password-email-sent',
    name: 'password-email-sent',
    component: () => import('../vues/pages/passwordEmailSentPage.vue')
  },
  {
    path: '/new-password',
    name: 'new-password',
    component: () => import('../vues/pages/newPasswordPage.vue')
  },
  {
    path: '/register-from-invitation',
    name: 'register-from-invitation',
    component: () => import('../vues/pages/registerFromInvitationPage.vue')
  },
  {
    path: '/directory',
    name: 'directory',
    component: () => import('../vues/pages/directoryPage.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../vues/pages/unifiedEmissionSourcesPage.vue'),
    // component: () => import('../vues/pages/projectsPage.vue'),
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('../vues/pages/unifiedEmissionSourcesPage.vue'),
  },
  {
    path: '/projects/sites/:project_id',
    name: 'site',
    component: () => import('../vues/pages/projectPage.vue'),
  },
  {
    path: '/projects/sites/:project_id/category/:category_id',
    name: 'category',
    component: () => import('../vues/pages/categoryPage.vue'),
  },
  {
    path: '/projects/sites/:project_id/category/:category_id/source/:module_id',
    name: 'emission-source',
    component: () => import('../vues/pages/emissionSource.vue'),
  },
  {
    path: '/projects/sites/:project_id/category/:category_id/subcategory/:sub_category_id/add',
    name: 'add-emission-source-with-selected-subcategory',
    component: () => import('../vues/pages/addEmissionSource.vue'),
  },
  {
    path: '/projects/sites/:project_id/category/:category_id/add',
    name: 'add-emission-source',
    component: () => import('../vues/pages/addEmissionSource.vue'),
  },
  // {
  //   path: '/projects/sites/:project_id/scope/:scope_id/providers',
  //   name: 'providers',
  //   component: () => import('../vues/pages/providersPage.vue'),
  // },
  // {
  //   path: '/projects/sites/:project_id/scope/:scope_id/waste-treatment',
  //   name: 'waste-treatment',
  //   component: () => impor../vues/old/wasteTreatmentPage.vuevue'),
  // },
  // {
  //   path: '/projects/sites/:project_id/scope/:scope_id/waste-treatment/:module_id',
  //   name: 'emission-source-waste-treatment',
  //   component: () => import('../vues/pages/emissionSource.vue'),
  // },
  // {
  //   path: '/projects/:project_id/scope/:scope_id/waste-treatment/add',
  //   name: 'add-emission-source-waste-treatment',
  //   component: () => import('../vues/pages/addEmissionSource.vue'),
  // },
  // {
  //   path: '/projects/sites/:project_id/scope/:scope_id/customers',
  //   name: 'customers',
  //   component: () => impor../vues/old/customersPage.vuevue'),
  // },
  // {
  //   path: '/projects/sites/:project_id/scope/:scope_id/customers/:module_id',
  //   name: 'emission-source-customers',
  //   component: () => import('../vues/pages/emissionSource.vue'),
  // },
  // {
  //   path: '/projects/:project_id/scope/:scope_id/customers/add',
  //   name: 'add-emission-source-customers',
  //   component: () => import('../vues/pages/addEmissionSource.vue'),
  // },
  // {
  //   path: '/projects/sites/:project_id/scope/:scope_id/providers/:provider_id',
  //   name: 'provider',
  //   component: () => import('../vues/pages/providerPage.vue'),
  // },
  // {
  //   path: '/projects/sites/:project_id/scope/:scope_id/providers/:provider_id/:module_id',
  //   name: 'emission-source-provider',
  //   component: () => import('../vues/pages/emissionSource.vue'),
  // },
  // {
  //   path: '/projects/sites/:project_id/perimeters-creation',
  //   name: 'perimeters-creation',
  //   component: () => import('../vues/pages/old/perimetersCreationPage.vue'),
  // },
  // {
  //   path: '/projects/sites/:project_id/perimeters-creation-from-invoice',
  //   name: 'perimeters-creation-from-invoice',
  //   component: () => import('../vues/pages/old/perimetersCreationFromInvoicePage.vue'),
  // },
  // {
  //   path: '/projects/:project_id/scope/:scope_id/providers/:provider_id/add',
  //   name: 'add-emission-source-provider',
  //   component: () => import('../vues/pages/addEmissionSource.vue'),
  // },
  // {
  //   path: '/projects/sites/:project_id/scope/:scope_id/employees',
  //   name: 'employees',
  //   component: () => import('../vues/old/employeesPage.vue'),
  // },
  // {
  //   path: '/projects/sites/:project_id/scope/:scope_id/employees/:module_id',
  //   name: 'emission-source-employees',
  //   component: () => import('../vues/pages/emissionSource.vue'),
  // },
  {
    path: '/lca',
    name: 'lca',
    component: () => import('../vues/pages/lcaPage.vue'),
  },
  {
    path: '/lca/:id',
    name: 'lca-detail',
    component: () => import('../vues/pages/lcaDetailPage.vue'),
    props: true
  },
  {
    path: '/lca/:id/epd',
    name: 'lca-epd',
    component: () => import('../vues/pages/EpdReportPage.vue'),
    props: route => ({ lcaId: route.params.id })
  },
  {
    path: '/board',
    name: 'board',
    component: () => import('../vues/pages/carbonResultsPage.vue'),
  },
  {
    path: '/actions',
    name: 'actions',
    component: () => import('../vues/pages/pilotPage.vue'),
  },
  {
    path: '/action-plans',
    name: 'action-plans',
    component: () => import('../vues/pages/actionPlansPage.vue'),
  },
  {
    path: '/projected',
    name: 'projected',
    component: () => import('../vues/pages/projectedPage.vue'),
  },
  {
    path: '/trajectory-settings',
    name: 'trajectory-settings',
    component: () => import('../vues/pages/trajectorySettings.vue'),
  },
  {
    path: '/parameters',
    name: 'parameters',
    component: () => import('../vues/pages/parametersPage.vue'),
  },
  {
    path: '/actions/addplan',
    name: 'add-action-plan',
    component: () => import('../vues/pages/addCarbonActionPlan.vue'),
  },
  {
    path: '/actions/:action_plan_id',
    name: 'action-plan',
    component: () => import('../vues/pages/carbonActionPlan.vue'),
  },
  {
    path: '/progress',
    name: 'progress',
    component: () => import('../vues/pages/progressPage.vue'),
  },
  {
    path: '/compare',
    name: 'compare',
    component: () => import('../vues/pages/comparePage.vue'),
  },
  {
    path: '/progress/contact',
    name: 'contact',
    component: () => import('../vues/pages/contactPage.vue'),
  },
  {
    path: '/progress/contact/confirmation',
    name: 'contact-confirmation',
    component: () => import('../vues/pages/contactConfirmationPage.vue'),
  },
    {
    path: '/zelia',
    name: 'zelia',
    component: () => import('../vues/pages/zeliaPage.vue'),
  },
  {
    path: '/zelia/sites/:project_id',
    name: 'zelia-site',
    component: () => import('../vues/pages/zeliaProjectPage.vue'),
  },
  {
    path: '/library',
    name: 'library',
    component: () => import('../vues/pages/libraryPage.vue'),
  },
  {
    path: '/factors-library',
    name: 'factors-library',
    component: () => import('../vues/pages/factorsLibraryPage.vue'),
  },
  {
    path: '/action-plans-library',
    name: 'action-plans-library',
    component: () => import('../vues/pages/actionPlansLibraryPage.vue'),
  },
  {
    path: '/forms',
    name: 'forms',
    component: () => import('../vues/pages/formsPage.vue'),
  },
  {
    path: '/forms/create',
    name: 'formCreate',
    component: () => import('../vues/pages/formBuilderPage.vue'),
  },
  {
    path: '/forms/:id/edit',
    name: 'formEdit',
    component: () => import('../vues/pages/formBuilderPage.vue'),
  },
  {
    path: '/forms/:id/respond',
    name: 'formResponse',
    component: () => import('../vues/pages/formResponsePage.vue'),
  },
  {
    path: '/factors-library/:db_name',
    name: 'factorsPage',
    component: () => import('../vues/pages/factorsPage.vue'),
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('../vues/pages/policyPage.vue'),
  },
  {
    path: '/employees',
    name: 'employees',
    component: () => import('../vues/pages/employeesPage.vue'),
  },
  {
    path: '/cartography',
    name: 'cartography',
    component: () => import('../vues/pages/cartographyPage.vue')
  },
  {
    path: '/rules',
    name: 'rules',
    redirect: () => {
      localStorage.setItem('zeliaDashboardTabSelected', 'false')
      localStorage.setItem('zeliaRulesTabSelected', 'true')
      return { name: 'zelia' }
    }
  },
  {
    path: '/import-greenly',
    name: 'import-greenly',
    component: () => import('../vues/pages/importGreenlyPage.vue')
  },
  {
    path: '/import-zei',
    name: 'import-zei',
    component: () => import('../vues/pages/importZeiPage.vue')
  },
  {
    path: '/export',
    name: 'export',
    component: () => import('../vues/pages/exportPage.vue')
  },
  {
    path: '/no-access',
    name: 'no-access',
    component: () => import('../vues/pages/noAccessPage.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../vues/pages/notFoundPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
})

// Navigation guard for module-based access control
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  // Public routes (login, policy, etc.) - always accessible
  if (isPublicRoute(to.name)) {
    return next()
  }

  // If not authenticated, redirect to login
  if (!token) {
    return next({ name: 'login' })
  }

  // Routes accessible to all authenticated users (help, contact, etc.)
  if (isAuthenticatedRoute(to.name)) {
    return next()
  }

  // Admin-only routes (parameters, directory, library, employees)
  if (isAdminOnlyRoute(to.name)) {
    const isAdmin = localStorage.getItem('isAdmin') === 'true'
    if (!isAdmin) {
      return next(getFirstAuthorizedRoute())
    }
    return next()
  }

  // Check module-specific rights
  const requiredModule = getRequiredModule(to.name)
  if (requiredModule) {
    if (!hasModuleRight(requiredModule)) {
      return next(getFirstAuthorizedRoute())
    }
  }

  next()
})

export default router
